import React, { useEffect } from 'react';
import 'styles/base.sass';
import Router from './router';
import { clearDeprecatedGetMe } from 'service/local-data-provider';
import appLoader from 'distributor/app-loader';
import { SplashLoading } from 'feature/splash/splash-page';
import { config } from 'config';
import * as Sentry from '@sentry/browser';
import amplitude from 'service/amplitude';
import ReactGA from 'react-ga';
import { loadScript } from 'helpers/scirpt-loader';
import { AppProvider } from 'use-app';

// 在線上環境才會啟用 sentry
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({ dsn: config.sentryUrl });
  amplitude.init();
}

const App = () => {
  const { methods } = appLoader;
  let { isPending, error } = methods.useInit();

  useEffect(() => {
    const onResize = () => {
      document.documentElement.style.setProperty('--viewHeight', `${window.innerHeight}px`);
    };

    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  useEffect(() => {
    amplitude.init();
    ReactGA.initialize(config.googleAnalyticsCode);
    loadScript(`https://www.googleoptimize.com/optimize.js?id=${config.googleOptimizeContainerCode}`);
    loadScript('https://www.youtube.com/iframe_api');
    // 移除舊版保留的個資
    clearDeprecatedGetMe();
  }, []);

  // 等待 mobile 都解析完成後再往下 render 頁面
  if (isPending) {
    if (error) return error;
    return <SplashLoading />;
  }

  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
};

export default App;
